import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ImageCroppedEvent} from "ngx-image-cropper";
import {DialogService} from "../../../core/services/dialog.service";

export enum ImageCropFileFormat {
  jpg = 'jpeg',
  png = 'png',
}

@Component({
    selector: 'app-image-crop',
    templateUrl: './image-crop.component.html',
    styleUrls: ['./image-crop.component.scss'],
    standalone: false
})
export class ImageCropComponent implements OnInit {
  @Input() imageChangeEvent?: Event;
  @Input() maxWidth: number = 0;  // 指定した画像幅がどれだけ大きくてもここで指定した幅を最大幅としてリサイズする。0なら無効
  @Input() maxHeight: number = 0;  // 指定した画像高さがどれだけ大きくてもここで指定した高さを最大高としてリサイズする。0なら無効
  @Input() aspectRatio?: number; // 縦横比16:9なら「16 / 9」と指定
  @Input() set isShow(isShow: boolean) {
    this._isShow = isShow;

    if (!isShow) {
      this.isLoaded = false;
    }
  }

  @Input() format: ImageCropFileFormat = ImageCropFileFormat.png;

  @Output() changeImageFile: EventEmitter<Blob> = new EventEmitter<Blob>();

  _isShow: boolean = false;
  isLoaded: boolean = false;
  maintainAspectRatio: boolean = true;

  constructor(
    private dialogService: DialogService,
  ) {
  }

  ngOnInit(): void {
    if (this.aspectRatio === undefined) {
      // 任意の縦横比で切り取りを行えるようにするためにmaintainAspectRatioをfalseに指定した場合はaspectRatioの指定は無効となるが、
      // aspectRatioはnumber型を要求するのでデフォルト値の 1 / 1 を指定しておく
      this.maintainAspectRatio = false;
      this.aspectRatio = 1 / 1;
    }
  }

  imageCropped(event: ImageCroppedEvent): void {
    if (event.blob) {
      this.changeImageFile.emit(event.blob);
    }
  }

  imageLoaded(): void {
    this.isLoaded = true;
  }

  async loadImageFailed(): Promise<void> {
    await this.dialogService.alert({
      title: '読み込みエラー',
      content: 'ファイルの読み込みに失敗しました。再度お試しください。再度お試しいただいても読み込めない場合は他の画像を選択してください。'
    });
  }
}
